import { pessoaModel } from './pessoa'

export const clienteModel = {
  cliente: function () {
    return {
      id: '',
      obervacao: '',
      pessoa_id: '',
      pessoa: new pessoaModel.pessoa(),
    }
  }
}


// WEBPACK FOOTER //
// ./src/models/cliente.js